import { render, staticRenderFns } from "./formSelect.vue?vue&type=template&id=a974f810"
import script from "./formSelect.vue?vue&type=script&lang=js"
export * from "./formSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports